import C from "@/modules/dashboard/Dashboard.module.css";

import { MaskIcon } from "@/components/icon/MaskIcon.tsx";
import { cn } from "@/utils/classNames.ts";
import type React from "react";

interface ArrowProps {
    className?: string;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

export function PrevArrow({ className, onClick }: ArrowProps) {
    return (
        <div className={cn(className, C.PrevArrow)}>
            <button type="button" onClick={onClick}>
                <MaskIcon className="jp-arrow-thin-left-icon size-0.75rem" />
            </button>
        </div>
    );
}

export function NextArrow({ className, onClick }: ArrowProps) {
    return (
        <div className={cn(className, C.NextArrow)}>
            <button type="button" onClick={onClick}>
                <MaskIcon className="jp-arrow-thin-right-icon size-0.75rem" />
            </button>
        </div>
    );
}
